import moment from 'moment'

/**
 * @member {Boolean} checked
 * @member {moment} date_of_expire
 * @member {String} filename
 * @member {String} uuid_any
 */
export default class FileMeta {
  checked
  date_of_expire
  filename
  uuid_any
  number

  /**
   * @param {Boolean} checked
   * @param {moment|null} date_of_expire
   * @param {String} filename
   * @param {String} uuid_any
   * @param number
   */
  constructor({
    checked,
    date_of_expire,
    filename,
    uuid_any,
    number
  }) {
    const properties = {
      configurable: false,
      enumerable: true,
      writable: true
    }

    const momentDateOfExpire = moment(date_of_expire)

    checked = Boolean(Number(checked))
    date_of_expire = momentDateOfExpire.isValid() ? momentDateOfExpire : null
    filename = String(filename)
    uuid_any = String(uuid_any)

    Object.defineProperty(this, 'checked', Object.assign({ value: checked }, properties))
    Object.defineProperty(this, 'date_of_expire', Object.assign({ value: date_of_expire }, properties))
    Object.defineProperty(this, 'filename', Object.assign({ value: filename }, properties))
    Object.defineProperty(this, 'uuid_any', Object.assign({ value: uuid_any }, properties))
    Object.defineProperty(this, 'number', Object.assign({ value: number }, properties))
    Object.freeze(this)
  }
}
